export default "__VITE_ASSET__DOKEgYR3__"